import { render } from "./FooterContact.vue?vue&type=template&id=64985b5c&scoped=true"
const script = {}

import "./FooterContact.vue?vue&type=style&index=0&id=64985b5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64985b5c"]])

export default __exports__